<template>
  <div class="work-wrap">
    <div class="work-top-box">
      <div @click.stop="allClick" :class="activeBtn == 'all'?'active':''">全部工单</div>
      <div class="vertical"></div>
      <div @click.stop="dealClick" :class="activeBtn == 'deal'?'active':''">
        待处理（{{dealNum}}）
      </div>
      <div class="vertical"></div>
      <div @click.stop="finishClick" :class="activeBtn == 'finish'?'active':''">已完成</div>
    </div>

    <div class="work-center-box">
      <div class="mt-10 search-box">
        <el-input class="search-input" style="height:20px" v-model="faultName" placeholder="请输入名称关键词">
          <el-button slot="append" icon="el-icon-search" @click="searchHandle"></el-button>
        </el-input>
        <!-- <el-input type="year" v-model="month" style="width:180px;margin-left: 10px" placeholder="选择时间" @change="searchHandle"></el-input> -->
        <el-date-picker class="ml-5" v-model="month" type="year" placeholder="选择年" format="yyyy" value-format="yyyy" @change="searchHandle" clearable>
        </el-date-picker>
      </div>

      <div style="overflow-y:auto;height: calc(100% - 90px);" v-if="dataList.length" ref="dataViewRef">
        <div class="work-card-box mt-10" v-for="(item,i) in dataList" :key="i">
          <div class="work-title">
            <div class="title cell">{{item.faultName}}</div>
            <div class="work-status">
              <span v-if="item.isOverdue" style="color: #F56C6C">{{item.statusName}}（超期）</span>
              <span v-else>{{item.statusName}}</span>
            </div>
          </div>
          <div class="work-content-box mt-10">
            <div class="cell">安装位置：{{item.space}}</div>
            <div class="mt-5">故障类型：{{item.faultTypeName}}</div>
            <div class="mt-5">截止日期：{{item.handleEndTime}}</div>
            <div class="mt-5">下发时间：{{item.submitTime}}</div>
          </div>
          <div class="work-bottom-box mt-10">
            <div class="work-level" :style="{'color': item.urgencyLevel == 3?'#67C23A':item.urgencyLevel == 4?'#F56C6C':''}">{{item.urgencyLevelName}}</div>
            <div class="" v-if="item.status != 3 && item.status != 4" @click="dealHandle(item)">前往处理<i class="el-icon-arrow-right"></i></div>
            <div class="" v-else @click="detailHandle(item)">详情<i class="el-icon-arrow-right"></i></div>
          </div>
        </div>
      </div>
      <div v-else class="mt-20" ref="dataViewRef">
        <div style="color:#909399;text-align:center">暂无数据</div>
      </div>
    </div>

    <!-- 单点登录时跳转按钮 -->
    <div v-show="browser" class="browser-btn-wrap" @click="browserBtnClick">
      <div>故障上报</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      browser: sessionStorage.getItem('browser'),
      dealNum: 0,
      activeBtn: 'deal',
      faultName: '',
      month: '',
      dataList: [],

      wxReady: false, // 微信SDK是否已准备就绪

      startClientY: 0,
      endClientY: 0,
      touchmoveY: 0,
      isScrolledToTop: true,
    }
  },
  mounted() {
    document.addEventListener('touchstart', this.preventStartScroll, { passive: false });
    document.addEventListener('touchmove', this.preventScroll, { passive: false });
    document.addEventListener('touchend', this.preventEndScroll, { passive: false });
  },
  activated() {
    this.browser = sessionStorage.getItem('browser');
    this.activeBtn = this.$route.query.btn ? this.$route.query.btn : 'deal';
    this.searchHandle();
    this.getTipsNum();
    this.initWeChatSDK();
  },
  beforeDestroy() {
    document.addEventListener('touchstart', this.preventStartScroll);
    document.addEventListener('touchmove', this.preventScroll);
    document.addEventListener('touchend', this.preventEndScroll);
  },
  methods: {
    // 下拉刷新-开始
    preventStartScroll(event) {
      this.touchmoveY = 0;
      this.isScrolledToTop = this.$refs.dataViewRef.scrollTop === 0 ? true : false;
      this.startClientY = event.touches[0].clientY;
    },
    // 下拉刷新-移动
    preventScroll(event) {
      if (this.isScrolledToTop && (event.touches[0].clientY - this.startClientY > 0)) {
        event.preventDefault();
        this.touchmoveY = event.touches[0].clientY;
        // if (event.touches[0].clientY - this.startClientY > 160) {
        //   this.searchHandle();
        //   this.getTipsNum();
        // }
      }
    },
    // 下拉刷新-结束
    preventEndScroll(event) {
      if (this.touchmoveY - this.startClientY > 160) {
        this.searchHandle();
        this.getTipsNum();
      }
    },
    // 初始化微信SDK配置
    async initWeChatSDK() {
      try {
        this.wxReady = false;
        let params = {
          url: window.location.href
        };

        let res = await this.$http.get(this.$API.wechat_getSign, { params });
        const config = res.data;
        wx.config({
          debug: false,
          appId: config.appId,
          timestamp: config.timestamp,
          nonceStr: config.nonceStr,
          signature: config.signature,
          jsApiList: ['chooseImage', 'uploadImage', 'getLocalImgData']
        });
        wx.ready(() => {
          this.wxReady = true;
          console.log('微信SDK配置成功');
        });
        wx.error((res) => {
          console.error('微信SDK配置失败', res);
        });
      } catch (error) {
        console.error('获取微信签名失败', error);
      }
    },
    handleTouchStart(event) {
      this.startY = event.touches[0].clientY;
    },
    searchHandle() {
      let params = {
        status: this.activeBtn == 'deal' ? '1' : this.activeBtn == 'finish' ? '3' : '',
        faultName: this.faultName,
        orderYear: this.month
      }
      this.$http.get(this.$API.repair_order_getProcessingOrdersByHanderId, { params }).then(res => {
        this.dataList = res.data || [];
      })
    },
    allClick() {
      this.activeBtn = 'all';
      this.searchHandle();
    },
    dealClick() {
      this.activeBtn = 'deal';
      this.searchHandle();
      this.getTipsNum();
    },
    finishClick() {
      this.activeBtn = 'finish';
      this.searchHandle();
    },
    // 前往处理
    dealHandle(data) {
      let url = '/fault/work/detail?id=' + data.id + '&btn=' + this.activeBtn;
      window.location.assign(url);
      // this.$router.push({ path: '/fault/work/detail', query: { id: data.id, btn: this.activeBtn } });
    },
    // 详情
    detailHandle(data) {
      // this.$router.push({ path: '/fault/work/detail', query: { id: data.id, btn: this.activeBtn } });
      let url = '/fault/work/detail?id=' + data.id + '&btn=' + this.activeBtn;
      window.location.assign(url);
    },
    getTipsNum() {
      let params = {
        status: 1
      }
      this.$http.get(this.$API.repair_order_getProcessingOrdersCountByHanderId, { params }).then(res => {
        this.dealNum = res.data || 0;
      })
    },
    browserBtnClick() {
      this.$router.push('/fault/report');
    }
  },
}
</script>

<style lang="scss" scoped>
.work-wrap {
  height: 100%;
}
.work-top-box {
  display: flex;
  height: 40px;
  background-color: #fff;
  justify-content: space-evenly;
  align-items: center;
  font-size: 1.6rem;
  .active {
    color: #2f70ff;
  }
  .vertical {
    width: 1px;
    height: 20px;
    background-color: #f2f2f2;
  }
}
.work-center-box {
  padding: 0 10px;
  height: 100%;
}
.search-box {
  display: flex;
}
.work-card-box {
  background-color: #fff;
  border-radius: 8px;
  padding: 10px;
  .work-title {
    display: flex;
    .work-status {
      flex: 1 0 120px;
      text-align: right;
      font-size: 1.6rem;
    }
  }
  .work-content-box {
    padding: 10px;
    font-size: 1.6rem;
    border-radius: 6px;
    background-color: #f9fafd;
  }
  .work-bottom-box {
    display: flex;
    font-size: 1.6rem;
    justify-content: space-between;
  }
}

.browser-btn-wrap {
  position: fixed;
  bottom: 40px;
  right: 10px;
  background-color: #ecf5ff;
  padding: 10px 5px;
  border-radius: 8px 0 0 8px;
  writing-mode: vertical-rl;
  text-orientation: upright;
  cursor: pointer;
}
</style>

<style lang="scss">
.search-box {
  .search-input {
    .el-input-group__append {
      background-color: #fff;
      padding: 0 10px;
    }
  }
}
</style>